export const SuccessIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#10B981" />
    <path
      d="M14.5 7L8.5 13L5.5 10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#EF4444" />
    <path
      d="M13 7L7 13M7 7L13 13"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="10" fill="#3B82F6" />
    <path d="M10 9V14" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <circle cx="10" cy="6" r="1" fill="white" />
  </svg>
);

export const WarningIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 1L19 18H1L10 1Z" fill="#F59E0B" />
    <path d="M10 7V11" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <circle cx="10" cy="14" r="1" fill="white" />
  </svg>
);
